import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from 'src/app/modules/shared/models/products.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { Subscription } from 'rxjs';
import { DynamicMetaService } from 'src/app/modules/shared/services/dynamic-meta.service';
import { TitleService } from 'src/app/modules/shared/services/title.service';
import { DataLayerService } from 'src/app/modules/shared/services/data-layer/data-layer.service';
import { GoogleEventTypes } from 'src/app/modules/shared/enum/datalayer-event-types';
import { DeviceDetectorService } from 'src/app/modules/shared/services/device-detector/device-detector.service';
import { FACEBOOK_EVENT_TYPES } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.model';
import { MetaPixelService } from 'src/app/modules/shared/services/meta-pixel/meta-pixel.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
})
export class productDetailsComponent implements OnInit {
  product: Product;
  subscriptions: Subscription[] = [];
  isDesktop: boolean;
  private routeState;

  constructor(
    private panelService: PanelService,
    private route: ActivatedRoute,
    private router: Router,
    private deviceDetector: DeviceDetectorService,
    private titleService: TitleService,
    private dynamicMetaService: DynamicMetaService,
    private metaPixelService: MetaPixelService,
    private dataLayerService: DataLayerService
  ) {
    this.routeState = this.router.getCurrentNavigation().extras.state;
    this.deviceDetector.$breakpoint().subscribe((sizes) => {
      this.isDesktop = sizes.matches;
    });
  }

  ngOnInit(): void {
    this.getProductDetail();
    this.route.params.subscribe((params) => {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    });
  }

  private sendEcommerceEvents() {
    this.dataLayerService.pushGoogleEvent(
      GoogleEventTypes.VIEW_ITEM,
      this.product
    );
    this.metaPixelService.pushEvent(FACEBOOK_EVENT_TYPES.VIEW_CONTENT, {
      data: {
        content_ids: [`${this.product.id}`],
        contents: [
          {
            id: `${this.product.id}`,
            quantity: 1,
          },
        ],
        content_type: 'product',
        currency: this.product.currency_detail.code,
        value: 1,
      },
    });

    if (this.routeState?.hasNavigated && this.routeState?.homeIndexData) {
      this.dataLayerService.pushGoogleEvent(GoogleEventTypes.SELECT_ITEM, {
        ...this.product,
        index: `${this.routeState.homeIndexData.itemIndex}`,
      });
    }
  }

  getProductDetail() {
    const productSubscription = this.panelService
      .getProductDetail(this.route.snapshot.paramMap.get('id'))
      .subscribe((product: any) => {
        this.titleService.updateTitle(
          product.store_product_detail?.name || product.name
        );
        if (product.store_product_detail.metadata) {
          let generatedMeta = this.dynamicMetaService.loadMeta(
            product.store_product_detail.metadata
          );
          product.store_product_detail.metadata = generatedMeta;
        }
        if (product.store_product_detail.javascript_metadata) {
          let generatedMeta = this.dynamicMetaService.loadMeta(
            product.store_product_detail.javascript_metadata
          );
          product.store_product_detail.javascript_metadata = generatedMeta;
        }
        this.product = product;
        this.sendEcommerceEvents();
      });

    this.subscriptions.push(productSubscription);
  }

  ngOnDestroy() {
    if (this.product?.store_product_detail.metadata) {
      this.dynamicMetaService.unLoadMeta(
        this.product.store_product_detail.metadata
      );
    }
    if (this.product?.store_product_detail.javascript_metadata) {
      this.dynamicMetaService.unLoadMeta(
        this.product.store_product_detail.javascript_metadata
      );
    }
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
